import React from "react";
import moment from "moment";

import BusinessReportTable from "./BusinessReportTable";
import cx from "../ui/cx";
import { EmptyState, LoadingState } from "../ui/TableStateRow";
import {
  cardClass,
  cardContentClass,
  cardDescriptionClass,
  cardHeaderClass,
  filterTitleClass,
} from "../ui/styles";
import {
  BusinessReportFilterProps,
  BusinessReportTabProps,
} from "../../types/businessReport";

const tabListClass =
  "items-center rounded-md text-muted-foreground flex h-auto w-max flex-nowrap justify-start gap-1 bg-[#113F67]/5 p-1";
const tabButtonClass =
  "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";
const tabActiveClass = "bg-[#113F67] text-white shadow";
const tabInactiveClass = "text-[#34699A]";

const formatDate = (value: string) => moment(value).format("DD-MM-YYYY");

type Props = {
  tabs: BusinessReportTabProps[];
  activeTab: string;
  appliedFilter: BusinessReportFilterProps | null;
  isLoading: boolean;
  error: string | null;
  onTabChange: (key: string) => void;
};

const BusinessReportTabs = ({
  tabs,
  activeTab,
  appliedFilter,
  isLoading,
  error,
  onTabChange,
}: Props) => {
  const current = tabs.find((tab) => tab.key === activeTab) || tabs[0];

  return (
    <div className={cardClass}>
      <div className={cardHeaderClass}>
        <div className={filterTitleClass}>મોડ્યુલ વાઇઝ વિગતો</div>
        {appliedFilter && (
          <div className={cardDescriptionClass}>
            {formatDate(appliedFilter.fromDate)} થી{" "}
            {formatDate(appliedFilter.toDate)}
          </div>
        )}
      </div>

      <div className={cardContentClass}>
        {isLoading ? (
          <LoadingState />
        ) : !current ? (
          <EmptyState label={error || "કોઈ રેકોર્ડ મળ્યો નથી"} />
        ) : (
          <>
            <div className="overflow-x-auto pb-1">
              <div role="tablist" className={tabListClass}>
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    aria-selected={tab.key === current.key}
                    onClick={() => onTabChange(tab.key)}
                    className={cx(
                      tabButtonClass,
                      tab.key === current.key ? tabActiveClass : tabInactiveClass
                    )}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="mt-4 space-y-6">
              {current.sections.map((section) => (
                <BusinessReportTable
                  key={section.key}
                  section={section}
                  showTitle={current.sections.length > 1}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default BusinessReportTabs;
